/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { getEstateGeneratedTitle } from '../../lib/common/estate.mjs'
import CustomerLink from '../customer/CustomerLink'
import Ref from '../Ref'
import Amount from '../transaction/Amount'
import { getEstateLink } from '../../lib/links/estateLinks'
import { getManagementReportViewLink } from '../../lib/links/managementReportLinks'
import SelectionInput from '../../../../client/js/components/selection/SelectionInput'
import { Table } from '@mantine/core'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import EstatePhoto from '../estate/EstatePhoto'
import EstateInfoHoverCard from '../estate/EstateInfoHoverCard'

export type ManagementReportListItemProps = {
  imageHeight?: number,
  imageWidth?: number,
  item: ManagementReport,
  selectable?: boolean
}

function ManagementReportListItem (props: ManagementReportListItemProps) {
  const {
    imageHeight = 90,
    imageWidth = 160,
    item: report,
    selectable
  } = props

  return (
    <Table.Tr>
      {selectable
        ? <Table.Td>
          <SelectionInput value={report.id} />
        </Table.Td>
        : null}
      <Table.Td>
        <EstatePhoto
          photos={report.Estate.Photos}
          height={imageHeight}
          width={imageWidth}
        />
      </Table.Td>
      <Table.Td>
        <AnchorLink
          to={getManagementReportViewLink({
            customerId: report.customerId,
            estateId: report.estateId,
            year: report.year
          })}
        >
          <Ref value={report.reference} />
        </AnchorLink>
      </Table.Td>
      <Table.Td>
        <CustomerLink customer={report.Customer} />
      </Table.Td>
      <Table.Td>
        <Ref me="sm" value={report.Estate.reference} />
        <EstateInfoHoverCard estateId={report.estateId}>
          <span>
            <AnchorLink to={getEstateLink(report.estateId)}>
              {getEstateGeneratedTitle(report.Estate)}
            </AnchorLink>
          </span>
        </EstateInfoHoverCard>
      </Table.Td>
      <Table.Td ta="end">
        <Amount value={report.balance} inherit colored withCurrency />
      </Table.Td>
    </Table.Tr>
  )
}

export default ManagementReportListItem
